export const BACKLOG_READY_FOR_USER_MARK = 'BACKLOG_READY_FOR_USER_MARK';
export const BACKLOG_INTERACTIVE_MARK = 'BACKLOG_INTERACTIVE_MARK';
